import * as React from 'react';
import styled from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';

import ClientOnly from 'components/ClientOnly';
import Button from 'components/Button';
import VisuallyHidden from 'components/VisuallyHidden';
import Icon from 'components/Icon';

import { color, theme } from 'styles/utils';

const StyledDialogTriggerWrapper = styled.div`
  position: relative;
`;

const StyledDialogTrigger = styled(Dialog.Trigger)`
  cursor: pointer;
  inset: 0;
  position: absolute;
  width: 100%;
`;

const StyledDialogOverlay = styled(Dialog.Overlay)`
  backdrop-filter: blur(4px);
  display: grid;
  height: 100%;
  inset: 0;
  overflow-y: auto;
  padding: 1.5rem;
  place-items: center;
  position: fixed;
  width: 100vw;
  z-index: ${theme('zIndex.dialog')};

  ::before {
    background: ${color('darkestTeal')};
    content: '';
    opacity: 0.75;
    position: absolute;
    inset: 0;
  }
`;

const StyledDialogContent = styled(Dialog.Content)`
  position: relative;
  width: fit-content;
  filter: drop-shadow(0 1rem 4rem #0004) drop-shadow(0 0.25rem 1rem #0004);
`;

const StyledDialogChildren = styled.div`
  > * {
    max-height: 90vh;
  }
`;

const StyledDialogCloseButton = styled(Button)`
  border-radius: 100%;
  padding: 0.75rem;
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(50%, -50%);
`;

export default function Expander({ children, hiddenTrigger }) {
  return (
    <ClientOnly>
      <Dialog.Root>
        <StyledDialogTriggerWrapper>
          {children}
          <StyledDialogTrigger>
            <VisuallyHidden>
              {hiddenTrigger || 'Click to open dialog'}
            </VisuallyHidden>
          </StyledDialogTrigger>
        </StyledDialogTriggerWrapper>

        <Dialog.Portal>
          <StyledDialogOverlay>
            <StyledDialogContent>
              <Dialog.Close asChild>
                <StyledDialogCloseButton>
                  <Icon name="close" />
                  <VisuallyHidden>Close</VisuallyHidden>
                </StyledDialogCloseButton>
              </Dialog.Close>
              <StyledDialogChildren>{children}</StyledDialogChildren>
            </StyledDialogContent>
          </StyledDialogOverlay>
        </Dialog.Portal>
      </Dialog.Root>
    </ClientOnly>
  );
}
